import React, { PropTypes, Component } from 'react'
import R from 'ramda'
import { fromJS } from 'immutable'
import Promise from 'bluebird'
import {
  searchCountries,
  searchCitieswithProperties
} from '../../sources/SearchSource'
import { slugify, unslugify } from '../../Utils'
import SearchResult from './SearchResult'

import showBackButton from '../../components/showBackButton'

const propTypes = {
  user: PropTypes.object,
  router: PropTypes.object,
  params: PropTypes.object,
  location: PropTypes.object
}

class SearchByCity extends Component {
  constructor (props) {
    super(props)
    this.state = {
      parent: {},
      cities: [],
      canLoadMore: true,
      isFetching: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.loadMore = this.loadMore.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { cities, canLoadMore, isFetching } = this.state
    if (
      !fromJS(cities).equals(fromJS(nextState.cities)) ||
      canLoadMore !== nextState.canLoadMore ||
      isFetching !== nextState.isFetching
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    const { params, location } = this.props
    let countryId = location.query.id || this.state.countryId
    this.setState({ isFetching: true }, () => {
      let query = countryId
        ? { id: countryId }
        : { where: { name: params.country } }

      searchCountries(query)
        .then(response => {
          let country = response.data[0] || response.data
          return Promise.all([
            country,
            searchCitieswithProperties({ id: country.id })
          ])
            .spread((country, response) => {
              this.setState({
                parent: country,
                cities: response.data.results,
                canLoadMore:
                  response.data.results.length < response.data.noElements,
                isFetching: false
              })
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    })
  }

  handleClick (el) {
    this.props.router.push(
      '/search/region/' +
        this.props.params.continent +
        '/' +
        this.props.params.country +
        '/' +
        slugify(el.city) +
        '?id=' +
        el.id
    )
  }

  loadMore () {
    const { cities, parent } = this.state
    this.setState({ isFetching: true }, () => {
      searchCitieswithProperties({ id: parent.id, skip: cities.length })
        .then(response => {
          let list = R.sortBy(R.prop('city'), R.union(cities, response.data))
          this.setState({
            cities: list,
            canLoadMore: list.length < response.data.noElements,
            isFetching: false
          })
        })
        .catch(error => console.log(error))
    })
  }

  render () {
    const { country, continent } = this.props.params
    const { canLoadMore, isFetching, cities, parent } = this.state
    const title = unslugify(country)
    const path = {
      continent: unslugify(continent),
      country: unslugify(country),
      city: null
    }
    return (
      <SearchResult
        router={this.props.router}
        type={'city'}
        path={path}
        handleClick={this.handleClick}
        parent={parent}
        results={cities}
        title={title}
        loadMore={this.loadMore}
        canLoadMore={canLoadMore}
        isFetching={isFetching}
      />
    )
  }
}

SearchByCity.propTypes = propTypes

export default showBackButton(SearchByCity)



// WEBPACK FOOTER //
// ./src/pages/Search/SearchByCity.js